import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import Base from 'ol/layer/Base';
import Select from 'ol/interaction/Select';
import Draw from 'ol/interaction/Draw';
import GeometryType from 'ol/geom/GeometryType';
import Feature from 'ol/Feature';
import * as olEvents from 'ol/events';
import { pointerMove, singleClick } from 'ol/events/condition';
import Style from 'ol/style/Style';
import Vector from 'ol/layer/Vector';
import Image from 'ol/layer/Image';
import { LogService } from '../../../src/app/modules/domain/services/logging/log.service';
import Interaction from 'ol/interaction/Interaction';
import MapBrowserEvent from 'ol/MapBrowserEvent';
import Projection from 'ol/proj/Projection';
import ImageWMS from 'ol/source/ImageWMS';
import GeoJSON from 'ol/format/GeoJSON';

@Injectable()
export class InteractionService {

    constructor(
        private _http: Http,
        private _log: LogService
    ) { }

    getDrawInteraction(type: GeometryType, ondrawend: Subject<Feature>): Draw {
        const draw: Draw = new Draw({
            type: type ? type : GeometryType.POLYGON
        });
        draw.on('drawend', (event: olEvents.EventsKey) => {
            ondrawend.next(event.feature);
        });
        return draw;
    }

    getSelectInteraction(layer: Base, hover: boolean, onselected: Subject<Feature>): Select | Interaction {
        let select: Select | Interaction;
        if (layer instanceof Vector) {
            select = new Select({
                layers: [layer],
                condition: hover ? pointerMove : singleClick,
                style: new Style()
            });
            select.on('select', (event: olEvents.EventsKey) => {
                if (layer.getVisible()) {
                    event.selected.forEach((olFeature: Feature) => {
                        onselected.next(olFeature);
                    });
                }
            });
        } else if (layer instanceof Image) {
            select = new Interaction({
                handleEvent: (event: MapBrowserEvent): boolean => {
                    if (event.type === 'click' && layer.getVisible()) {
                        try {
                            const resolution: number = event.map.getView().getResolution();
                            const projection: Projection = event.map.getView().getProjection();
                            const source: ImageWMS = layer.getSource() as ImageWMS;
                            const url: string = source.getGetFeatureInfoUrl(event.coordinate, resolution, projection, { 'INFO_FORMAT': 'application/json' });
                            this._http.get(url).subscribe((response: Response) => {
                                const json: any = response.json();
                                const geoJSON: GeoJSON = new GeoJSON();
                                if (json.features) {
                                    json.features.forEach((ftr: any) => {
                                        onselected.next(geoJSON.readFeature(ftr));
                                    });
                                } else {
                                    onselected.next(geoJSON.readFeature(json));
                                }
                            });
                        } catch (e) {
                            this._log.error('SelectToolComponent:', e);
                        }
                    }
                    return true;
                }
            });
        }
        return select;
    }
}



// WEBPACK FOOTER //
// ./libs/map/services/interaction.service.ts